module.exports = __webpack_public_path__ + "assets/droplet-document.5b254cbe.svg";